export default {
    state: {
        personalData: {},

    },
    getData() {
        return this.state
    },
    setPersonalData(data) {
        this.state.personalData = data
    },
}
